import Api, {urls} from '../../../services/api'
import {ApiResponseList, matchContentFinalScore} from '../types'
import logException from '../../../services/sentry'
import showNotification from '../../../functions/notification'
import {matchContentFinalScoreActions} from '../../slices'
import {AppDispatch} from '../..'
import {apiErrorBlock} from '../../../functions/utils'

export const getMatchContentFinalScore = (id: number) => async (dispatch: AppDispatch) => {
  try {
    const response: ApiResponseList<matchContentFinalScore> = await Api.get(
      `${urls.matchContent}/${id}/final_score`,
    )
    const {status, message, data} = response.data
    if (status && data) {
      await dispatch(
        matchContentFinalScoreActions.updateMatchContentFinalScore({
          matchContentFinalScore: data as matchContentFinalScore,
        }),
      )
    }
    logException(new Error(message))
    if (message) showNotification({title: 'Error', message, type: 'danger'})
    // eslint-disable-next-line prettier/prettier
  } catch (e: any) {
    apiErrorBlock(e)
  }
}

export const updateMatchContentFinalScore =
  (id: number, params: FormData) => async (dispatch: AppDispatch) => {
    try {
      const response: ApiResponseList<matchContentFinalScore> = await Api.post(
        `${urls.matchContent}/${id}/${urls.matchFinalScore}`,
        params,
      )
      const {status, message} = response.data
      if (status && message) {
        if (message) showNotification({title: 'Success', message, type: 'success'})
        await dispatch(getMatchContentFinalScore(id))
        return true
      }
      logException(new Error(message))
      if (message) showNotification({title: 'Error', message, type: 'danger'})
      return false
    } catch (e: any) {
      apiErrorBlock(e)
      return false
    }
  }

export const clearMatchContentFinalScore = () => async (dispatch: AppDispatch) => {
  try {
    await dispatch(matchContentFinalScoreActions.clearMatchContentFinalScore())
    return true
  } catch (e: any) {
    apiErrorBlock(e)
    return false
  }
}
